module.exports = __webpack_public_path__ + "img/leech.64f601ee.png";